// Import Plugin/Modules
import Overlay from './vendor/overlay.js';
import Glide, {Controls, Swipe, Autoplay} from '@glidejs/glide/dist/glide.modular.esm';
import Glightbox from 'glightbox';

// Overlay (for mobile nav)
new Overlay('#mainMenu', '.header_menuButton');
new Overlay('#mainMenu', '.mainMenu_button--close');

const carousel = document.querySelector('.glide');
const carouselItems = document.querySelectorAll('.glide__slides > div').length;

if (carousel && carouselItems > 1) {

    window.addEventListener('load', function () {
        const glideCarousel = new Glide('.glide', {
            type: 'carousel',
            perView: 1,
            autoplay: 5000
        });

        // Automated height on Carousel build
        glideCarousel.on('build.after', function () {
            glideHandleHeight();
        });

        // Automated height on Carousel change
        glideCarousel.on('run.after', function () {
            glideHandleHeight();
        });

        glideCarousel.mount({Controls, Swipe, Autoplay});

    });

    // Resize height
    function glideHandleHeight() {
        const activeSlide = document.querySelector('.glide__slide--active');
        const activeSlideHeight = activeSlide ? activeSlide.offsetHeight : 0;

        const glideTrack = document.querySelector('.glide__track');
        const glideTrackHeight = glideTrack ? glideTrack.offsetHeight : 0;

        if (activeSlideHeight !== glideTrackHeight) {
            glideTrack.style.height = `${activeSlideHeight}px`;
        }
    }

}

// Video Modal
const videoModal = document.querySelector('.hero_main_content--video');

if (videoModal) {
    const lightbox = Glightbox({
        selector: '.u-modal'
    });
}
